var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenStrScope(_vm.value, _vm.mode) && _vm.screenStrScope(_vm.value, _vm.mode).name)?_c('div',[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.title)?_c('span',[_vm._v("：")]):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.screenStrScope(_vm.value, _vm.mode).name)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }